module.exports = __webpack_public_path__ + "img/canbadge_round_25mm.05d2ace0.png";